export enum EventStatuses {
  STARTED = 'started',
  COMPLETED = 'completed',
  INCOMPLETE = 'incomplete',
}
